// service/auth/authService.ts

import { store } from '../../redux/store';
import axiosInstance from '../axiosInstance';


// ----- new apis -----

const config = {
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
}

export const login = async (formData: any) => {
  try {
    const response = await axiosInstance.post('user/login', formData);
    return response?.data
  } catch (error) {
    // console.log('Error logging in:', error);
    throw new Error(error || 'An error occurred while logging in');
  }
};

export const registerEmail = async (formData: any) => {
  try {
    const response = await axiosInstance.post('user/register', formData);
    return response?.data
  } catch (error) {
    // console.log('Error registering:', error);
  }
};
export const sendEmail = async (formData: any) => {
  try {
    const response = await axiosInstance.post('communication/send-email', formData);
    return response?.data
  } catch (error) {
    // console.log('Error registering:', error);
  }
};
export const registerPhone = async (formData: any) => {
  try {
    const response = await axiosInstance.post('user/register-phone', formData);
    return response
  } catch (error) {
    throw error
  }
};

export const verifyPhone = async (formData: any) => {
  try {
    const response = await axiosInstance.post('user/verify-phone', formData);
    return response?.data
  } catch (error) {
    return error?.response?.data
  }
};

export const verifyEmail = async (formData: any) => {
  // console.log('Verifying email:', formData.email);
  
  try {
    const data = await axiosInstance.post('user/unique-email', formData);
    return data;
  } catch (error) {
    throw error; // Rethrow the error to handle it in the calling function
  }
};

export const googleLogin = async(formData: any) => {
  try{
    const data = await axiosInstance.post('user/google', formData);
    return data
  } catch (error) {
    // console.log("Error on Google Auth", error)
  }
}

export const autoVerify = async(formData: any) => {
  try{
    const response = await axiosInstance.post( "user/auto-verify", formData );
    return response?.data
  } catch (error) {
    console.log("Error on Google Auth", error)
  }
}


export const handlerefreshToken = async () => {
  try {
    const { refreshToken } = store.getState().user;
    const response = await axiosInstance.post('user/get-access-token', { refreshToken });
    const { accessTokenJWT: accessToken } = response?.data?.accessToken;
    return accessToken
  } catch (error) {
    console.log("Error  here!!!")
    console.error('Error refreshing token:', error);
    return false;
  }
};
